import { useEffect, useState } from 'react';

/**
 * Tracks `prefers-reduced-motion: reduce`. Pure DOM, no framer-motion.
 *
 * Returns `true` when the user has expressed a system-level preference for
 * reduced motion. The globe scene checks this to:
 *   - disable auto-rotate
 *   - swap fly-to camera tweens for instant repositioning
 *   - skip shimmer / pulse-glow animations
 *
 * SSR-safe: defaults to `false` when `window` is undefined.
 */
export function useReducedMotion(): boolean {
  const [prefers, setPrefers] = useState<boolean>(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  });

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    const handler = (e: MediaQueryListEvent) => setPrefers(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return prefers;
}
